<template>
  <List
    :envInfoType="3"
    envName="生产环境" />
</template>

<script>
import List from '@/components/business/traceinfo/list'
export default {
  name: 'WorkEnvList',
  components: { List },
  props: {},
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() { },
  mounted() { },
  methods: {}
}
</script>
<style lang="stylus" scoped></style>
